/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S4_Li5Inputs */

const en_guide_json_schema_s4_li5 = /** @type {(inputs: Guide_Json_Schema_S4_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Testing</strong>: Validate API responses against expected schemas in integration tests`)
};

const ko_guide_json_schema_s4_li5 = /** @type {(inputs: Guide_Json_Schema_S4_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>테스트</strong>: 통합 테스트에서 예상 스키마에 대해 API 응답 검증`)
};

const ja_guide_json_schema_s4_li5 = /** @type {(inputs: Guide_Json_Schema_S4_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>テスト</strong>: インテグレーションテストでAPIレスポンスを期待されるスキーマに対して検証`)
};

/**
* | output |
* | --- |
* | "<strong>Testing</strong>: Validate API responses against expected schemas in integration tests" |
*
* @param {Guide_Json_Schema_S4_Li5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s4_li5 = /** @type {((inputs?: Guide_Json_Schema_S4_Li5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S4_Li5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s4_li5(inputs)
	if (locale === "ko") return ko_guide_json_schema_s4_li5(inputs)
	return ja_guide_json_schema_s4_li5(inputs)
});